import { DateTime } from 'luxon';

import getColDurationAsMs from './getColDurationAsMs';
import addColDurations from './addColDurations';

const getIntervalAsCoords = (itvl, dateMode, colSize) =>
  itvl * colSize / getColDurationAsMs(dateMode);
  
const getBarXCoords = (
  entry, 
  dateMode, 
  colSize, 
  colOffset, 
  ganttStartDate = DateTime.local()
) => {
  const startOffsetDate = addColDurations(ganttStartDate, dateMode, colOffset);
  const unitColSize = getColDurationAsMs(dateMode);
  
  const entryStartOffsetItvl = entry.start.diff(startOffsetDate);
  const entryEndOffsetItvl = entry.end.diff(startOffsetDate);
  
  return {
    start: getIntervalAsCoords(entryStartOffsetItvl, dateMode, colSize),
    end: getIntervalAsCoords(entryEndOffsetItvl, dateMode, colSize),
  };
};

export default getBarXCoords;
